import React from 'react';
import '../../shared/PerksModal/PerksModal.scss';
import { Button } from '@one-thd/sui-atomic-components';
import { PerksModal } from '../../shared/PerksModal/PerksModal';
import { buttonText } from '../../../../constants';
export var HasPerksModal = function (_a) {
    var isMobile = _a.isMobile, statePack = _a.statePack;
    var modalState = statePack.modalState, detailState = statePack.detailState;
    var openPerksDetailModal = modalState[0], setOpenPerksDetailModal = modalState[1];
    var currentPerkDetails = detailState[0], setCurrentPerkDetails = detailState[1];
    var setShowModal = function (shouldShow) {
        if (!shouldShow)
            setCurrentPerkDetails({});
        setOpenPerksDetailModal(shouldShow);
    };
    return (React.createElement(PerksModal, { currentPerkDetails: currentPerkDetails, showFinalWarning: true, title: "".concat(currentPerkDetails.perkTitle, " Details"), showModal: openPerksDetailModal, setShowModal: setShowModal, hasError: false, isLoading: false, showHowTo: true }, currentPerkDetails.perkStatus === 'ACTIVE' &&
        currentPerkDetails.giftCard && (React.createElement(Button, { fullWidth: isMobile, variant: "secondary", onClick: function () {
            window.open('https://www.homedepot.com/myaccount/payments', '_blank', 'noopener,noreferrer');
        } }, buttonText.cardsAndAccounts))));
};
